import { useCallback, useState } from 'react'
import { useQuery } from 'react-query'
import { SortByType, SortingType } from '@components/Table/interface'
import { useAuthentication } from '@hooks/useAuthentication'
import { useClient } from '@hooks/useClient'
import { TopRankTableProps } from '../TopRankTable/interface'
import { columns } from './columns'
import { TopCharacterTableProps } from './interface'

export function withTopCharacterTable(Component: React.FC<TopRankTableProps>) {
  function WithTopCharacterTable({ searchParam }: TopCharacterTableProps) {
    const client = useClient()
    const { isAuthenticated } = useAuthentication()
    const [sort, setSort] = useState<SortByType>({
      key: '',
      order: '' as SortingType,
    })

    const handleSort = useCallback(({ key, order }: SortByType) => {
      setSort({ key, order })
    }, [])

    const { data = [], isLoading } = useQuery(
      ['highest-character-donate', searchParam, sort],
      () =>
        client?.saleClient.getHighestCharacterDonate({
          searchParam,
          sort,
        }),
      {
        enabled: isAuthenticated,
      }
    )

    const pageProps = {
      title: 'ตัวละครยอดสนับสนุนสูงสุด',
      className: 'max-h-[485px] pr-[20px]',
      data,
      columns,
      handleSort,
      isLoading,
    }
    return <Component {...pageProps} />
  }

  return WithTopCharacterTable
}
